<template>
  <div>
      <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <select-input v-model="form.department_id" :error="form.errors.department_id" class="pr-6 pb-8 w-full" :label="__('Department')" :required="true">
                          <option :value="null" />
                          <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select-input>
              <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " :label="__('Name')" />
              <select-input v-model="form.ticket_department_id" :error="form.errors.ticket_department_id" class="pr-6 pb-8 w-full" label="Departamento">
                          <option :value="null" />
                          <option v-for="d in ticket_departments" :key="d.id" :value="d.id">{{ d.name }}</option>
              </select-input>
<!--              <text-input v-model="form.color" :error="form.errors.color" class="pr-6 pb-8 w-full lg:w-1/2" label="Color" />-->
          

            <label class="flex toggle_swtich items-center cursor-pointer mb-5">
                  <span class="form-label block mr-5">Privado</span>
                  <div class="relative">
                      <input type="checkbox" class="sr-only" v-model="form.private" />
                      <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                      <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                  </div>
            </label>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!category.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar departamento</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar departamento</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/inertia-vue3'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
      Link,
      Head,
      SelectInput
  },
  layout: Layout,
  props: {
    title: String,
    category: Object,
    departments : Array,
    ticket_departments : Array,

  },
  remember: 'form',
  data() {

    return {
      form: this.$inertia.form({
          name: this.category.name,
          color: this.category.color,
          private : (this.category.private) ? true  : false,
          department_id : this.category.department_id,
          ticket_department_id : this.category.ticket_department_id
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('categories.update', this.category.id))
    },
    destroy() {
      if (confirm('¿Estás seguro de que deseas eliminar este departamento?')) {
        this.$inertia.delete(this.route('categories.destroy', this.category.id))
      }
    },
    restore() {
      if (confirm('¿Estás seguro de que deseas restaurar este departamento?')) {
        this.$inertia.put(this.route('categories.restore', this.category.id))
      }
    },
  },
}
</script>
